<template lang="pug">
.joinroom
  //- small {{ room }}
  .room-wrapper
    .back-btn.d-flex.align-items-center.border-0.p-0( @click="$emit('room-back')") 
      i.fas.fa-left-long.ms-1
      span {{ $t('ui.back') }}
    .room-item
      .room-container(:class="getBackgroundCss(roomData)")  
        .room-info-group
          .room-info
            .room-pool {{ $t('ui.pool') }}:
              span.amount.ml-1 {{ $numeral(roomData.points).format("0,0") }}
              span.tournament-jackpot.ml-2(v-if="roomData.jackpot > 0")
                i.fad.fa-chevron-double-up
                span {{ roomData.jackpot * 100 }}%
            .room-no {{ $t('ui.room') }}: {{ roomData.room_id }}
          .room-status
            .status(:class="'room_' + roomData.room_status") {{ $t('m.ROOM_' + roomData.room_status) }} 
            .status.private-room(v-if="roomData.room_type == 2")
              i.fa.fa-lock.me-1
              | {{ $t('ui.private') }}
            template(v-else)
              .status.private-room.exclusive(v-if="!!roomData.system_id && roomData.system_id.toUpperCase() != 'MERCEDES'")
                i.fad.fa-crown.mr-2
                span {{ $t('ui.exclusive') }}
        .room-close(v-if="(new Date(roomData.start_time)) > (new Date())")
          small.mr-2 {{ $t("ui.last_join_time") }} 
          span(:data-tick="ticker") {{ getCountDown(roomData.start_time) }}
          
      .join-now-wrapper
        .player(v-if="roomData.room_count < roomData.room_limit")
          i.fas.fa-users
          span.mx-1 {{ $t('ui.players') }}:
          span {{ roomData.room_count }} / {{ roomData.room_limit }}
        .player(v-else) {{ $t('message.room_full') }}
        .join-info(v-if="(roomData.room_join > 0)")
          span.tournament-fc-light(v-if="roomData.room_host === 1") {{ $t('message.my_room') }}
          span.tournament-fc-light(v-else) {{ $t('message.room_joined') }}
          .trophy(v-if="roomData.room_status == 3 && (roomData.position != null) && ([1,2,3].includes(roomData.position))")
            img.img-fluid(:src="'/images/tournament/trophy' + roomData.position.toString() + '.svg'")
        .join-info(v-else-if="roomData.room_rate > 0") {{ $t('ui.entry_fee') }}:
            span.amount.mx-1 {{ roomData.room_rate }}
              small.ms-1 ( {{ currencyCode }} {{ $numeral(roomData.room_rate / roomData.rate).format("0,0.00")  }} )
        .join-info(v-else) {{ $t('ui.free_room') }}
      .room-info-wrapper
        .page-group
          .tc-content
            iframe(:src="rulesUrl" loading="lazy")
            .tc-footer
              .d-flex.agreement.align-items-center
                .select-league-checkbox.me-1
                  label.date-check
                    input(type="checkbox" v-model="isAgree")
                    span.checkmark-date
                label.form-check-label 
                  | {{ $t("message.accept_terms") }}
              
              .d-block.mt-1
                .password-container(v-if="isAgree && roomData.room_type == 2")
                  .d-flex.align-items-center
                    .me-3 {{ $t('ui.password') }}:
                    .room-rate-input
                      input.form-control(type="text" v-model="roomPassword" :placeholder="$t('message.pin_code')" style="width: 100px;" minlength="6" maxlength="6" pattern="[0-9]*" inputmode="numeric" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false")
                    //- small.room-limit-text.ml-2(style="color: #00ff0088;" v-if="feedback.roomPassword") {{ feedback.roomPassword }}
              
            ul.nav.nav-pills.tournament-pills
              li.nav-item.flex-fill(data-bs-toggle='modal' @click="joinNow(roomData)" :disabled="!isAgree")
                .nav-link.tnm-mybet
                  i.far.fa-sign-in
                  |  {{ $t('ui.join_now') }}
              li.nav-item.flex-fill
                a(type='button' data-dismiss='modal' @click="$emit('room-leave')")
                  .nav-link.tnm-mybet
                    i.fas.fa-door-open.mr-2
                    | {{ $t('ui.leave_room') }}

  //-   //- .room-container(:class="getBackgroundCss(roomData)")
  //-   //-   .d-flex.justify-content-between.align-items-center
  //-   //-     div
  //-   //-       div
  //-   //-         | {{ $t('ui.pool') }}:
  //-   //-         span.amount {{ roomData.points }}
  //-   //-         span.tournament-jackpot.ml-2(v-if="roomData.jackpot > 0")
  //-   //-           i.fad.fa-chevron-double-up
  //-   //-           span {{ roomData.jackpot * 100 }}%
  //-   //-       div {{ $t('ui.room') }}: {{ roomData.room_id }}
  //-   //-     .d-flex
  //-   //-       .private-room(v-if="roomData.room_type == 2")
  //-   //-         i.fa.fa-lock.mr-1(aria-hidden='true')
  //-   //-         | {{ $t('ui.private') }}
  //-   //-       template(v-else)
  //-   //-         .private-room.exclusive(v-if="roomData.system_id.toUpperCase() != 'MERCEDES'")
  //-   //-           i.fad.fa-crown.mr-2
  //-   //-           span {{ $t('ui.exclusive') }}
  //-   //-       .public-room.mr-1(v-if="roomData.room_type != 2 && roomData.room_host === 1")
  //-   //-         i.fa.fa-home(aria-hidden='true')
  //-   //-         | {{ $t('ui.owner') }}
  //-   //-       .status(:class="'room_' + roomData.room_status") {{ $t('m.ROOM_' + roomData.room_status) }}
  //-         //- a.result-btn
  //-         //-   i.fa.fa-list-ul(aria-hidden='true')
  //-   a(v-if="roomData.room_status === 0 && roomData.room_join === 0 && roomData.room_count < roomData.room_limit")
  //-     .join-now-wrapper
  //-       .player
  //-         i.fad.fa-users
  //-         span.mx-1 {{ $t('ui.players') }}:
  //-         span {{ roomData.room_count }} / {{ roomData.room_limit }}
  //-       div(v-if="roomData.room_rate > 0")
  //-         | {{ $t('ui.entry_fee') }}:
  //-         span.amount.mr-1.ml-1 {{ roomData.room_rate }}
  //-         small(style="color: #08ff00cc;") ( {{ currencyCode }} {{ $numeral(roomData.room_rate / roomData.rate).format("0,0.00")  }} )
  //-       div(v-else)
  //-         | {{ $t('ui.free_room') }}
  //-   a(v-else)
  //-     .join-now-wrapper
  //-       .player(v-if="roomData.room_count < roomData.room_limit")
  //-         i.fad.fa-users
  //-         span.mx-1 {{ $t('ui.players') }}:
  //-         span {{ roomData.room_count }} / {{ roomData.room_limit }}
  //-       .player(v-else) {{ $t('message.room_full') }}
  //-       div(v-if="(roomData.room_join > 0)")
  //-         span.tournament-fc-light(v-if="roomData.room_host === 1") {{ $t('message.my_room') }}
  //-         span.tournament-fc-light(v-else) {{ $t('message.room_joined') }}
  //- 
  
</template>

<script>
import config from "@/config";
import errors from "@/errors";
import { EventBus } from "@/library/_event-bus.js";
import service from "@/views/tournament/library/_xhr.js";

export default {
  components: { },
  props: {
    roomData: {
      type: Object
    }
  },
  data() {
    return {
      ticker: 0,
      isAgree: false,
      roomPassword: "",
      loading: {
        roomJoin: false,
        validateTournament: false
      }
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace('UST', 'USDT');
    },
    rulesUrl() {
      var lang = "en";
      switch (this.$store.getters.language) {
        case "en":
        case "cn":
        // case "id":
        // case "kr":
        // case "th":
        // case "tw":
        // case "vi":
          lang = this.$store.getters.language;
          break;
        default:
          lang = "en";
      }
      return config.rulesUrl + "/tournament/mrules-" + lang + ".html";
    }
  },
  mounted() {
    this.isAgree = false;
  },
  methods: {
    
    getCountDown(e) {
      var endTime = this.$dayjs(e).subtract(1, 'minute').format("YYYY-MM-DDTHH:mm:ss")
      var difference = this.$dayjs.utc(endTime + "+0800").diff(this.$dayjs.utc());
      var days = Math.floor(difference / (1000 * 60 * 60 * 24));
      var hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((difference / 1000 / 60) % 60);
      var seconds = Math.floor((difference / 1000) % 60);
      if (days < 0 || hours < 0 || minutes < 0 || seconds < 0) {
        return this.$t("ui.match_started");
      } else {
        if (days === 0) {
          if (hours === 0) {
            if (minutes === 0) {
              return seconds + "s";
            } else {
              return minutes + "m";
            }
          } else {
            return hours + "h " + minutes + "m";
          }
        } else {
          return days + "d " + hours + "h " + minutes + "m";
        }
      }
    },
    getBackgroundCss(room){
      let logo = room.league_logo
      let type = room.room_type
      let bg = ''

      if(logo && type != 2) {
        return logo.split('.')[0]
      } else {
        return bg
      }
    },
    enterRoom(room) {
      this.$emit("room-enter", room);
    },
    cancel() {
      this.$emit("room-leave");
      // this.room.room_join == 0 ? this.room.room_join = 1 : this.room.room_join = 0;
    },
    joinNow(room) {
      if (!this.isAgree) {
        this.$swal("Warning", this.$t("message.accept_required"), "warning");
        return;
      }

      // $("#passwordModal").modal("show");

      if (room.room_type === 2) {
        // check room password must be string and 6 digit number else show error
        if (isNaN(this.roomPassword) || this.roomPassword.length != 6) {
          this.$swal("Warning", this.$t("error.roomPasswordRequired"), "warning");
          return;
        }
      }

      if (room.room_rate > 0) {
        this.$swal({
          title: this.$t("ui.confirmation"),
          html: this.$t("message.deduct_confirm"),
          type: "info",
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            this.validateTournament(this.roomJoin);
          }
        });
      } else {
        this.validateTournament(this.roomJoin);
      }
    },
    validateTournament(callback) {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession,
      };

      this.loading.validateTournament = true;
      service.validateTournament(json).then(
        (result) => {
          this.loading.validateTournament = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;

            if (result.success == true) {
              if (result.data.result === "true") {
                if (callback) callback();
              } else {
                this.$helpers.handleFeedback("tournamentDisabled");
              }
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        (err) => {
          console.log(err);
          this.loading.validateTournament = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    roomJoin() {
      if (this.loading.roomJoin) {
        return;
      }

      var roomPassword = this.roomPassword;

      if (this.roomData.room_type === 2) {
        // check room password must be string and 6 digit number else show error
        if (isNaN(roomPassword) || roomPassword.length != 6) {
          this.$helpers.handleFeedback("invalidRoomPassword");
          return;
        }
      } else {
        roomPassword = "123456";
      }

      var operator_type = this.$store.getters.operatorType;
      var parent_id = this.$store.getters.parentId;

      // make json
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        room_id: this.roomData.room_id,
        room_type: this.roomData.room_type,
        room_pwd: roomPassword,
        operator_type: operator_type,
        parent_id: parent_id,
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession
      };

      var url = config.tournamentUrl().roomjoin;
      if (operator_type && operator_type == 2) {
        url = config.tournamentUrl().vroomjoin;
      }

      this.loading.roomJoin = true;
      service.roomJoin(url, json).then(
        result => {
          this.loading.roomJoin = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              this.roomData.room_join = 1;
              EventBus.$emit("roomEnterById", this.roomData.room_id);
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        err => {
          console.log(err);
          this.loading.roomJoin = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getBackground(e) {
      return config.tournamentBackgroundPath + e;
    },
  }
}
</script>